<template>
  <div class="content-panel">
    <ts-loading-banner :loading="loadingPhoto">
      <form action="">
        <fieldset>
          <legend>{{ $t('thesis.viewAttachmentFile') }}</legend>
          <div class="drive-wrapper drive-grid-view" style="height: 65vh">
            <div class="grid-items-wrapper ts-overflow-y-auto ts-overflow-x-hidden">
              <div id="img-frame">
                <img :src="logo_file_src" />
              </div>
            </div>
          </div>
        </fieldset>
      </form>

    </ts-loading-banner>
  </div>
</template>
<script>
export default {
  name: 'list-view',
  props: ['resources'],

  data: function () {
    return {
      loading: false,
      waiting_save: false,
      fileChange: false,
      loadingPhoto: false,
      file: '',
      logo_file_src:
        '',

    }
  },

  async created() {
    this.logo_file_src = this.resources.attached_agreement
  },
  methods: {

  },



}
</script>

<style scoped>
#logo_file {
  display: none;
}

#img-frame img {
  object-fit: contain;
  width: 308px;
  height: 401px;
  /* box-shadow: 0 4px 6px rgba(0, 0, 0, .1); */
  border-radius: 10px;
  padding: 5px;
  text-align: center;
  border-radius: 3px;
}

#label_logo_file {
  cursor: pointer;
}
</style>
